import { GlobalAdmin } from "coolremote-sdk";
import { getUnsupportedSyncReason, SyncAction } from "./deviceSyncConfig";
import { unknownEntitiesFromError } from "./deviceSyncUtils";

export function getDeviceSyncEntities(deviceId: string) {
  return GlobalAdmin.getDeviceSyncEntities(deviceId);
}

export async function validateDeviceSync(deviceId: string, entities?: string[]): Promise<any> {
  try {
    return await GlobalAdmin.validateDeviceSync(deviceId, entities);
  } catch (error) {
    const unknown = unknownEntitiesFromError(error);
    if (entities?.length && unknown.length) {
      const remaining = entities.filter((entity) => !unknown.includes(entity));
      if (remaining.length > 0 && remaining.length < entities.length) {
        return validateDeviceSync(deviceId, remaining);
      }
    }
    throw error;
  }
}

export function validateDeviceSyncEntity(deviceId: string, entity: string) {
  return GlobalAdmin.validateDeviceSyncEntity(deviceId, entity);
}

export function manageDeviceSyncEntity(
  deviceId: string,
  entity: string,
  action: SyncAction
) {
  const blocked = getUnsupportedSyncReason(entity, action);
  if (blocked) {
    return Promise.reject(new Error(blocked));
  }
  return GlobalAdmin.manageDeviceSyncEntity(deviceId, entity, action);
}
